import ListingCard from '@global/ListingCard'
import { Col, Row } from '@styles/global.styled'
import Head from 'next/head'
import React, { useEffect } from 'react'

const ListingCardGrid = ({ items, minPage, onPropertyClick }) => {
  const handleViewDetail = (propertyId) => {
    // Use the parent's onPropertyClick handler if provided (for localStorage approach)
    if (onPropertyClick) {
      const propertyIdNumber = propertyId.replace('property-', '')
      onPropertyClick(propertyIdNumber)
      return
    }

    // Fallback to sessionStorage approach if no onPropertyClick provided
    const element = document.getElementById(propertyId)
    if (element) {
      const rect = element.getBoundingClientRect()
      sessionStorage.setItem('searchViewportOffset', rect.top)
      sessionStorage.setItem('searchLastViewedItem', propertyId)
    }
  }

  useEffect(() => {
    // Only use sessionStorage restore if onPropertyClick is not provided
    if (onPropertyClick) return

    const lastViewedItem = sessionStorage.getItem('searchLastViewedItem')
    if (items?.findIndex((it) => `property-${it.id}` === lastViewedItem) === -1)
      return

    const savedViewportOffset = parseInt(
      sessionStorage.getItem('searchViewportOffset') || '0',
      10
    )

    if (lastViewedItem) {
      setTimeout(() => {
        const element = document.getElementById(lastViewedItem)
        if (element) {
          const rect = element.getBoundingClientRect()
          const offsetDiff = rect.top - savedViewportOffset
          window.scrollTo({
            top: window.pageYOffset + offsetDiff,
            behavior: 'auto',
          })
          sessionStorage.removeItem('searchViewportOffset')
          sessionStorage.removeItem('searchLastViewedItem')
        }
      }, 100)
    }
  }, [items, onPropertyClick])

  return (
    <Row gutter={20}>
      {items.map((item, i) => {
        const data = ListingCard.ApiDataToProps(item)
        return (
          <React.Fragment key={`quick-view-${i}`}>
            {i < 2 && (
              <Head>
                {data.dataSource.image_url && (
                  <link
                    rel='preload'
                    as='image'
                    href={data.dataSource.image_url}
                  />
                )}
              </Head>
            )}
            <Col md={6} key={i} data-id={data.id} flex>
              <ListingCard
                quickload={i < 2}
                {...data}
                results
                page={Math.floor(i / 12) + minPage}
                onViewDetail={handleViewDetail}
              />
            </Col>
          </React.Fragment>
        )
      })}
    </Row>
  )
}

export default ListingCardGrid
